import { useTranslation } from 'react-i18next';
import { CheckIcon, XIcon } from '@heroicons/react/outline';

function OnboardingGenerateToast({ title, subtitle, status, onDismiss }: { title: string; subtitle: string; status: 'generating' | 'complete' | 'error'; onDismiss?: () => void }) {
  const { t } = useTranslation();
  const heading = status === 'complete'
    ? t('Complete')
    : status === 'error'
      ? t('Failed')
      : t('Generating 1 File...');

  return (
    <div className="pointer-events-auto w-full rounded-lg border-[0.67px] border-[#c4b9ae] overflow-hidden bg-gradient-to-b from-white from-75% to-[#f1f1f1]">
      <div className="flex items-center justify-between h-11 px-6 bg-black">
        <span className="font-gilroy font-semibold text-base text-white tracking-[-0.02em]">{heading}</span>
        {onDismiss && (
          <button type="button" className="text-white hover:text-white/70" onClick={onDismiss} aria-label={t('Dismiss')}>
            <XIcon className="w-3 h-3" />
          </button>
        )}
      </div>
      <div className="flex items-center gap-4 px-6 pt-5 pb-8">
        <div className="relative flex items-center justify-center w-12 h-12 flex-shrink-0 rounded-[5px] bg-[#ffa8ac] border-[3px] border-[#ffe6e7]">
          <div className="relative w-5 h-7 overflow-hidden rounded-[1px] bg-[#e40a13]">
            <div className="absolute top-0 right-0 w-0 h-0 border-solid border-t-[7px] border-l-[7px] border-t-[#a90007] border-l-transparent" />
            <span className="absolute inset-x-0 top-[36%] text-center font-mono font-bold text-[9.5px] leading-none text-white tracking-[-0.02em]">
              PDF
            </span>
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-gilroy font-semibold text-base text-black tracking-[-0.02em] truncate">{title}</div>
          <div className="mt-1.5 font-gilroy font-semibold text-[13px] leading-none text-gray-600 truncate">{subtitle}</div>
        </div>
        {status === 'generating' && (
          <div className="w-8 h-8 flex-shrink-0 rounded-full border-[3px] border-blue/10 border-t-blue animate-spin" />
        )}
        {status === 'complete' && (
          <div className="flex items-center justify-center w-8 h-8 flex-shrink-0 rounded-full bg-blue text-white">
            <CheckIcon className="w-4 h-4" />
          </div>
        )}
      </div>
    </div>
  );
}

export default OnboardingGenerateToast;
